import {Fragment} from "react";
import BrandSession from "./components/BrandSession";
import WelcomeToSession from "./components/WelcomeToSession";
import OverviewToSession from "./components/OverviewSession";
import FeatureAppSession from "./components/FeatureAppSession";
import TestimonialSession from "./components/TestimonialSession";
import MainBlogPost from './components/MainBlogPost';
function Home(){
    return (
        <Fragment>
            <WelcomeToSession/>
            <OverviewToSession/>
            <BrandSession/>
            <FeatureAppSession/>
            <MainBlogPost/>
            <TestimonialSession/>
        </Fragment>
    )
}

export default Home